import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfigService } from '../../services';
import { Router, NavigationEnd} from '@angular/router';
import { CommonService, ExtendedRoute } from '@increff/commons';
import { APP_ROUTES } from '../../route-config';

@Component({
    selector: 'com-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit, OnDestroy {
    pageHeading = '';
    pageHeaderSubscription: Subscription;
    //resolves true/false

    public crumbs = [];
    public parentDetails;
    public moduleDetails;
    public pageDetails;

    private filteredAppRoutes = APP_ROUTES;

    constructor(private configService: ConfigService, private router: Router, private commonService: CommonService) {
        this.router.events.subscribe((event) => this.update(event));
        this.onResize();
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.commonService?.initTooltip('.crud-buttons');
    }

    ngOnInit() {
        this.pageHeaderSubscription = this.configService.pageHeader.subscribe(pageHeader => {
            this.pageHeading = pageHeader;
            this.onResize();
        });
    }

    ngAfterViewInit(): void {
        this.commonService?.initTooltip('com-page-header');
        this.onResize();
    }

    ngOnDestroy() {
        this.pageHeaderSubscription.unsubscribe();
    }

    private update(event) {
        if(!event || !(event instanceof NavigationEnd)) return;
        const url = event.urlAfterRedirects.length == 1 ? 'home' : event.urlAfterRedirects.split('?')[0]; //Ignore only slash as it gives two tokens on splitting and query parameters
        const tokens = url.split('/');
        let node: ExtendedRoute;
        let fullUrl = '';
        tokens.shift();
        this.crumbs = [];
        for(const obj of tokens) {
            node = this.findNode(node?.children || this.filteredAppRoutes, obj);
            //Compute url up to now
            fullUrl += '/' + node.path;
            const crumb = {...node, ...{path: fullUrl, active: false}};
            this.crumbs.push(crumb);
        }
        const lastCrumb = this.crumbs[this.crumbs.length - 1];
        this.pageDetails = lastCrumb;
        this.moduleDetails = this.crumbs[this.crumbs.length - 2];
        this.parentDetails = this.crumbs[this.crumbs.length - 3];
    }

    private findNode(tree, token): ExtendedRoute {
        if(!token) return tree?.[0];
        for(const node of tree) {
            if(node?.path === token) return node;
            return tree?.find(node1 => node1?.path === token) ?? {path: ''};
        }
    }
}
